module.exports = __webpack_public_path__ + "Icono_Buscar-Blanco_126px.png";